import i18n from 'modules/core/lib/i18n'

export default function employeeStatus(list: string[]): string[] {
  return list.map((value: string) => {
    switch (value) {
      case 'active':
        return i18n.t('custom_reports.especial_filters.employee_status.options.active')
      case 'inactive':
        return i18n.t('custom_reports.especial_filters.employee_status.options.inactive')
      default:
        return ''
    }
  })
}
